import styled from 'styled-components';
import { getHideStyes, getResponsiveStyles } from '../helpers';
import { spacing, spacingDebugColors } from '../../../defaultTheme';
const InlineSpacer = styled.span `
  display: inline-flex;
  flex-direction: column;
  flex: 1;
  min-width: ${({ size }) => `${spacing[size || 'base']}px`};
  max-width: ${({ size }) => `${spacing[size || 'base']}px`};
  ${({ debug, size, respondToBreakpoints, hideOnBreakpointDown, hideOnBreakpointUp, hideOnlyOnBreakpoints }) => {
    let styles = respondToBreakpoints
        ? getResponsiveStyles(size, ['min-width', 'max-width'], respondToBreakpoints)
        : '';
    styles += getHideStyes(hideOnBreakpointUp, hideOnBreakpointDown, hideOnlyOnBreakpoints, 'display: none;');
    // Add background/min-height when debug is true
    if (debug) {
        styles += `
        background-color: ${spacingDebugColors.inline};
        min-height: 5px;
      `;
    }
    return styles;
}}
`;
export default InlineSpacer;
